// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__YixVS","row":"ProcedureTreatmentSummary_row__1ili-"};